import { OPEN_TEXT_SEARCH_EXPERIMENT } from '~/constants/common/openTextSearch';
import useIsInExperiment from './useIsInExperiment';

export default function useIsInTextSearchExperiment() {
  return useIsInExperiment(OPEN_TEXT_SEARCH_EXPERIMENT, 'treatment');
}
